import type { z } from "@hono/zod-openapi";
import type { AdminPoolResponse } from "@admin-api/_lib/contracts/pool";
import { ApiRequestError } from "@admin/lib/api";

export type PoolOverview = z.infer<typeof AdminPoolResponse>;

export async function getPoolOverview(): Promise<PoolOverview> {
  const res = await fetch("/api/pool", { credentials: "same-origin" });
  if (!res.ok) {
    throw new ApiRequestError("could not load the pool", "request_failed", res.status);
  }
  return (await res.json()) as PoolOverview;
}

/** "3m 5s" / "42s" / "-" for a heartbeat age. */
export function formatAge(sec: number | null): string {
  if (sec == null) return "-";
  return sec < 60 ? `${sec}s` : `${Math.floor(sec / 60)}m ${sec % 60}s`;
}
